// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import productReducer from './slices/productSlice';
import tiffinReducer from './slices/tiffinSlice';
import themeReducer from './slices/themeSlice';
import cartReducer from './slices/cartSlice';
import subscriptionReducer from './slices/subscriptionSlice';

import foodFilterReducer from './slices/foodFilterSlice';
import orderReducer from './slices/orderSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    tiffin: tiffinReducer,
    theme: themeReducer,
    orders: orderReducer,
     cart: cartReducer,
    subscription: subscriptionReducer,
     
     foodFilter: foodFilterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;